import { memo } from "react";
import "Components/NewPasswordPage/PasswordValidation/PasswordValidation.less";

type PasswordValidationProps = {
	password: string;
};

const passwordUppercaseRegex = /[A-Z]/;
const passwordLowercaseRegex = /[a-z]/;
const passwordNumberRegex = /[0-9]/;
const passwordSpecialCharRegex = /[!@#$%^&*]/;

function PasswordValidation(props: PasswordValidationProps) {
	const { password } = props;

	const getValidityClass = (isValid: boolean) => {
		return isValid ? "valid" : "invalid";
	};

	return (
		<div className="password-validation">
			<span>
				The password must meet the following requirements:
			</span>
			<ul className="validity-list">
				<li className={ getValidityClass(password.length >= 8 && password.length <= 16) }>
					At least 8~16 characters
				</li>
				<li className={ getValidityClass(passwordUppercaseRegex.test(password)) }>
					At least 1 uppercase letter: A~Z
				</li>
				<li className={ getValidityClass(passwordLowercaseRegex.test(password)) }>
					At least 1 lowercase letter: a~z
				</li>
				<li className={ getValidityClass(passwordNumberRegex.test(password)) }>
					At least 1 number: 0~9
				</li>
				<li className={ getValidityClass(passwordSpecialCharRegex.test(password)) }>
					At least 1 special character: !@#$%^&*
				</li>
			</ul>
		</div>
	);
}

export default memo(PasswordValidation);
